'use client';

import { CacheKeys } from '@headless-workspace/config';
import { AsyncData, ResultEmpty, unwrapResultSuccess } from '@headless-workspace/core-domain';
import useSWRImmutable from 'swr/immutable';
import { InitSessionValue } from '../../../server/lib/user/InitSessionValue';
import { UserSessionRepositorySpec } from '../../../server/lib/user/UserSessionRepository';
import { useAppLocale } from '../i18n';
import { mutateWithDataIfSuccess } from '../swr/SwrHelpers';

const INIT_USER_SESSION_KEY = 'user/init';

type UseUserSessionReturnType = AsyncData<InitSessionValue>;

export const useUserSession = (userSessionRepository: UserSessionRepositorySpec): UseUserSessionReturnType => {
    const locale = useAppLocale();

    const { isLoading, data } = useSWRImmutable(
        INIT_USER_SESSION_KEY,
        () => userSessionRepository.createSession(locale),
        {
            onSuccess: (data) => {
                const sessionData = unwrapResultSuccess(data);
                mutateWithDataIfSuccess(CacheKeys.User, sessionData?.data?.userInfo);
                mutateWithDataIfSuccess(CacheKeys.FavoriteStore, sessionData?.data?.favoriteStore);
                mutateWithDataIfSuccess(CacheKeys.Wishlist, sessionData?.data?.wishlist);
                mutateWithDataIfSuccess(CacheKeys.Basket, sessionData?.data?.basket);
            },
        },
    );

    if (!data || data.type !== 'success') {
        return { isLoading, result: ResultEmpty() };
    }

    return { isLoading, result: data };
};
